import { Notification, StylesScene } from '../../../../../models'
import { getNotificationImgPathes } from '../../resolveImgPath'

type TUserAskedToReadItem = {
    [key: string]: StylesScene
}

const UserAskedToReadItem: TUserAskedToReadItem = {
    'Group': {
        
    },
    'Public': {
        mainImg: {
            container: {
                width: 320,
                height: 417,
                position: 'absolute',
                top: 129,
                left: 25,
                transform: 'rotate(-12deg)',
                border: '7px solid #fff',
            }
        },
        avatar: {
            container: {
                width: 48,
                height: 48,
                borderRadius: '100%',
                overflow: 'hidden',
                position: 'absolute',
                bottom: 25,
                right: 215,
            }
        },
        docTitle: {
            container: {
                position: 'absolute',
                top: 681,
                left: 215,
                transform: 'rotate(-8deg)',
                padding: '6px',
                borderRadius: 4,
                zIndex: 2,
                backgroundColor: '#fff'
            },
            text: {
                fontFamily: 'Rubik',
                fontSize: 24,
                fontWeight: 'bold',
                fontStretch: 'normal',
                fontStyle: 'normal',
                lineHeight: 1.5,
                letterSpacing: 0,
                textAlign: 'center',
                color: '#0e0e14',
            }
        },
        staticNeedToRead: {
            container: {
                position: 'absolute',
                right: 24,
                top: 188 
            },
            text: {
                fontSize: 32,
                color: '#fff',
                fontWeight: 'bold',
                fontFamily: 'Roboto Slab',
                lineHeight: 1.81,
                letterSpacing: 1,
                textShadow: '2px 2px 2px rgba(0, 0, 0, 1)',
            }
        },
        dataTypeTitle: {
            container: {
                bottom: 51,
                right: 125,
                position: 'absolute',
                transform: 'rotate(-8deg)',
            },
            text: {
                fontFamily: 'Roboto Slab',
                textTransform: 'lowercase',
                opacity:.9,
                fontSize: 20,
                fornWeight: 500,
                lineHeight: 2.8,
                color: '#fff',
                textShadow: '0 2px 4px rgba(0, 0, 0, 0.15)'
            }
        },
        dudeStatic: {
            container: {
                position: 'absolute',
                top: 311,
                right: 31,
                zIndex: 3
            }
        },
        staticPleaseConfirm: {
            container: {
                width: 324,
                height: 128,
                position: 'absolute',
                right: 10,
                bottom: 215,
                transform: 'rotate(4deg)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '16px 32px',
                borderRadius: 6,
                backgroundColor: '#0e0e14',
                textAlign: 'center',
                boxSizing: 'border-box',
                zIndex: 4
            },
            text: {
                color: '#fff',
                fontSize: 36,
                fontWeight: 500,
                lineHeight: 1.33
            }
        }
    }
}

export const getUserAskedtoreadItemBackground = (notif: Notification): [string, StylesScene] => {
    return [getNotificationImgPathes(notif.systemActionTypeUid)['Default'], UserAskedToReadItem[notif.groupType]]
}